import { render, staticRenderFns } from "./loyalty-tier-container.vue?vue&type=template&id=ab8e5ad0&scoped=true&shadowMode"
import script from "./loyalty-tier-container.ts?vue&type=script&lang=ts&shadowMode"
export * from "./loyalty-tier-container.ts?vue&type=script&lang=ts&shadowMode"
function injectStyles (context) {
  
  var style0 = require("./loyalty-tier-container.scss?vue&type=style&index=0&id=ab8e5ad0&lang=scss&scoped=true&shadow=true&shadowMode")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "ab8e5ad0",
  null
  ,true
)

component.options.__file = "loyalty-tier-container.vue"
export default component.exports